<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <div v-if="users.length > 0" class="row mb-2">
                        <div class="col-sm-4">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ users.length }}</span>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Role Assign</th>
                                <th>Password Attempt</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(user, index) in users" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ user.name }}</td>
                                <td>{{ user.email }}</td>
                                <td>
                                    <a href="javascript:void(0);" class="action-icon" title="User Roles Details"
                                       @click.prevent="userRoleLogged(user.roles), $bvModal.show('role-logged')">
                                        <i class="mdi mdi-view-list addButton"></i>
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:void(0);" class="action-icon" title="User Password Attempt Details"
                                       @click.prevent="userPasswordAttempt(user.access_logs), $bvModal.show('password-attempt')">
                                        <i class="mdi mdi-view-list addButton"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 v-if="users.length === 0" class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
        <role-logged
                :roles="roles"
                @userRoleLogged="userRoleLogged"
        ></role-logged>
        <password-attempt
                :access_logs="access_logs"
                @userPasswordAttempt="userPasswordAttempt"
        ></password-attempt>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import RoleLogged from "../../modals/RoleLogged";
    import PasswordAttempt from "../../modals/PasswordAttempt";

    export default {
        page: {
            title: "Users List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, RoleLogged, PasswordAttempt},
        data() {
            return {
                title: "User List",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "User List",
                        active: true
                    }
                ],
                users: [],
                btn_edit: false,
                roles: '',
                access_logs: '',
            };
        },

        mounted() {
            this.getUsers();
        },
        methods: {
            getUsers() {
                http.get("api/users/role/logged/list").then(response => {
                    if (!response.error) {
                        this.users = response.data.users;
                    }
                });
            },
            userRoleLogged(roles){
                this.roles = roles
            },
            userPasswordAttempt(access_logs){
                this.access_logs = access_logs
            },
        },
    };
</script>
